module.exports = __webpack_public_path__ + "img/45d334a.png";